// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginLayoutTemplate__container-f3b93f .LoginLayoutTemplate__button-back-d1a7cb {
  position: absolute;
  top: 20px;
  inset-inline-start: 20px;
}

:root[dir=rtl] .LoginLayoutTemplate__button-back-d1a7cb {
  transform: scaleX(-1);
}

.LoginLayoutTemplate__info-cbe66b {
  text-align: center;
}

.LoginLayoutTemplate__content-c94370 {
  margin-top: 24px;
}

.LoginLayoutTemplate__sub-title-be8a64 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.LoginLayoutTemplate__message-c9d533 {
  margin-top: 8px;
}

.LoginLayoutTemplate__logo-wrapper-d09e28 {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.LoginLayoutTemplate__logo-bf5a74 {
  height: 80px;
  width: 80px;
}

.LoginLayoutTemplate__loading-wrapper-a9ea76 {
  padding: 24px 0;
}

.LoginLayoutTemplate__content-c94370 + .LoginLayoutTemplate__footer-cb75b6 {
  padding-top: 24px;
}

.LoginLayoutTemplate__footer-cb75b6 {
  text-align: center;
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/layouts/LoginLayout/LoginLayoutTemplate/LoginLayoutTemplate.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,wBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF","sourcesContent":[".container .button-back {\n  position: absolute;\n  top: 20px;\n  inset-inline-start: 20px;\n}\n\n:root[dir='rtl'] .button-back {\n  transform: scaleX(-1);\n}\n\n.info {\n  text-align: center;\n}\n\n.content {\n  margin-top: 24px;\n}\n\n.sub-title {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.message {\n  margin-top: 8px;\n}\n\n.logo-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 32px;\n}\n\n.logo {\n  height: 80px;\n  width: 80px;\n}\n\n.loading-wrapper {\n  padding: 24px 0;\n}\n\n.content + .footer {\n  padding-top: 24px;\n}\n\n.footer {\n  text-align: center;\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginLayoutTemplate__container-f3b93f`,
	"button-back": `LoginLayoutTemplate__button-back-d1a7cb`,
	"buttonBack": `LoginLayoutTemplate__button-back-d1a7cb`,
	"info": `LoginLayoutTemplate__info-cbe66b`,
	"content": `LoginLayoutTemplate__content-c94370`,
	"sub-title": `LoginLayoutTemplate__sub-title-be8a64`,
	"subTitle": `LoginLayoutTemplate__sub-title-be8a64`,
	"message": `LoginLayoutTemplate__message-c9d533`,
	"logo-wrapper": `LoginLayoutTemplate__logo-wrapper-d09e28`,
	"logoWrapper": `LoginLayoutTemplate__logo-wrapper-d09e28`,
	"logo": `LoginLayoutTemplate__logo-bf5a74`,
	"loading-wrapper": `LoginLayoutTemplate__loading-wrapper-a9ea76`,
	"loadingWrapper": `LoginLayoutTemplate__loading-wrapper-a9ea76`,
	"footer": `LoginLayoutTemplate__footer-cb75b6`
};
module.exports = ___CSS_LOADER_EXPORT___;
